export const Colors = {
    mainPurple: "#653FD2",
    secondPurple: "#7E72FA",
    hoverPurple: "#4A1FC6",
    black: "#000",
    detailBlack: "#3B3B3B", //내 이름, 방 이름 label
    backgroundColor: "#F6F5FC",
    white: "#FFF",
    detailWhite: "#E9E9E9",
    borderLine: "#7E7E7E", //2,3,4명 선택
    inputBorder: "#A9A9A9",
    inputColor: "#DADADA",
    boxShadowBlack: "rgba(0, 0, 0, 0.10)",
    boxShadowPurple: "rgba(163, 163, 253, 0.30)",
    footerColor: "#3E3E4A",
    fixGray: "#7E7E7E", //화목한 302호, 2명 등
    fixWhite: "#F9F9F9", // fixGray배경색
    font: "Noto Sans KR", //글씨체 
    errorColor: "#FF1E1E",
};